import React from 'react';
import { Box, Button, Divider, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { AppleIcon, GoogleIcon } from '../icons';

/**
 * "Or continue with" divider plus the Google / Apple social-auth buttons, shared
 * by the login and registration entry screens so they stay in sync.
 */
export default function SocialAuthButtons({
  onSelect,
}: {
  onSelect: (provider: 'google' | 'apple') => void;
}) {
  const { t } = useTranslation();
  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
        <Divider sx={{ flex: 1 }} />
        <Typography variant="caption" sx={{ color: 'text.secondary', whiteSpace: 'nowrap' }}>
          {t('login.orContinueWith')}
        </Typography>
        <Divider sx={{ flex: 1 }} />
      </Box>

      <Box sx={{ display: 'flex', gap: 2 }}>
        <SocialButton
          icon={<GoogleIcon />}
          label={t('login.continueWithGoogle')}
          onClick={() => onSelect('google')}
        />
        <SocialButton
          icon={<AppleIcon />}
          label={t('login.continueWithApple')}
          onClick={() => onSelect('apple')}
        />
      </Box>
    </>
  );
}

function SocialButton({
  icon,
  label,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}) {
  return (
    <Button
      onClick={onClick}
      variant="outlined"
      fullWidth
      startIcon={icon}
      sx={(theme) => ({
        flex: 1,
        borderRadius: '9999px',
        color: theme.app.foreground,
        borderColor: theme.app.borderStrong,
        '&:hover': {
          borderColor: theme.app.borderStrong,
          backgroundColor: theme.app.secondary,
        },
      })}
    >
      {label}
    </Button>
  );
}
